import { JsonPipe } from "@angular/common";
import { Component, Input, OnChanges } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { DefaultComponent } from "src/app/default.component";
import { MarkerData } from "../template-map.component";

@Component({
  selector: "app-default-marker-display",
  imports: [JsonPipe],
  templateUrl: "./default-marker-display.component.html",
  styleUrl: "./default-marker-display.component.less",
})
export class DefaultMarkerDisplayComponent<T = unknown> extends DefaultComponent implements OnChanges {
  @Input()
  public data: MarkerData<T>[] | null;

  public selectedIndex: BehaviorSubject<number>;

  public constructor() {
    super();
    this.data = null;
    this.selectedIndex = new BehaviorSubject(0);
  }

  public ngOnChanges(): void {
    this.selectedIndex.next(0);
  }

  public next(): void {
    if (!this.data) return;
    let nextIndex = this.selectedIndex.value + 1;
    if (nextIndex > this.data.length - 1) {
      nextIndex = 0;
    }
    this.selectedIndex.next(nextIndex);
  }

  public previous(): void {
    if (!this.data) return;
    let nextIndex = this.selectedIndex.value - 1;
    if (nextIndex < 0) {
      nextIndex = this.data.length - 1;
    }
    this.selectedIndex.next(nextIndex);
  }
}
